import React, { FormEventHandler, useState } from 'react';

import { Button, DialogActions, DialogContent } from '@mui/material';

import { VARIANT_OF_REFUND_SURCHARGE } from '~/consts/refund';

import { CollectionReason } from '../../types';
import CaseIDAndReasons from '../Common/CaseIDAndReasons';
import { CogsAdjustmentVccBanner } from '../Common/CogsAdjustmentBanner';
import MarkCancelled from '../Common/MarkCancelled';
import { shouldSkipVccForCogsAdjustment } from '../Utils/RefundUtils';

import SelectRefundVariantWithSurcharge from './SelectRefundVariantWithSurcharge';

interface Props {
  currencyCode?: string;
  decrementStep: () => void;
  defaultCaseId: string;
  defaultComment: string;
  hasSurcharge?: boolean;
  onSubmit: FormEventHandler<HTMLFormElement>;
  reason: CollectionReason;
  surchargeAmount?: number;
  disablePartialRefund?: boolean;
  onSurchargeToggleChange?: (value: boolean) => void;
  groupRefundCeiling?: number;
  approvedCogsAdjustmentAmount?: number | null;
  costCurrencyCode?: string;
}

export default function PackageAmendment({
  currencyCode,
  decrementStep,
  defaultCaseId,
  defaultComment,
  hasSurcharge = false,
  onSubmit,
  reason,
  surchargeAmount,
  disablePartialRefund = false,
  onSurchargeToggleChange,
  groupRefundCeiling,
  approvedCogsAdjustmentAmount,
  costCurrencyCode,
}: Props) {
  const [variantOfRefund, setVariantOfRefund] = useState<string>();
  const [markCancelled, setMarkCancelled] = useState<string>();
  // Same rule the payload uses
  const showVccBanner = shouldSkipVccForCogsAdjustment(
    { approved_cogs_adjustment_amount: approvedCogsAdjustmentAmount },
    markCancelled,
  );

  return (
    <>
      <DialogContent dividers>
        <form onSubmit={onSubmit} id="package-amendment-form">
          <CaseIDAndReasons reason={reason} defaultComment={defaultComment} defaultCaseId={defaultCaseId} />
          <SelectRefundVariantWithSurcharge
            hasSurcharge={hasSurcharge}
            currencyCode={currencyCode}
            surchargeAmount={surchargeAmount}
            variantOfRefund={variantOfRefund}
            setVariantOfRefund={setVariantOfRefund}
            disablePartialRefund={disablePartialRefund}
            onSurchargeToggleChange={onSurchargeToggleChange}
            defaultShouldSurchargeBeRefunded="true"
            groupRefundCeiling={groupRefundCeiling}
          />
          {variantOfRefund && <input type="hidden" name="variantOfRefund" value={variantOfRefund} />}
          {showVccBanner && (
            <CogsAdjustmentVccBanner amount={approvedCogsAdjustmentAmount} currencyCode={costCurrencyCode} />
          )}
          {variantOfRefund !== VARIANT_OF_REFUND_SURCHARGE && (
            <MarkCancelled onChange={(_, value: string) => setMarkCancelled(value)} />
          )}
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={decrementStep}>Back</Button>
        <Button type="submit" variant="contained" form="package-amendment-form">
          Continue
        </Button>
      </DialogActions>
    </>
  );
}
